export default {
  seo: {
    home: {
      title: "IGNIVA — Superficies y soluciones para arquitectura e interiores",
      desc: "IGNIVA selecciona y representa marcas internacionales de materiales, superficies y tecnología para arquitectura e interiores. Lithotech, en distribución exclusiva en Portugal por IGNIVA.",
    },
    about: {
      title: "IGNIVA — Curaduría, apoyo técnico y seguimiento comercial | IGNIVA",
      desc: "IGNIVA selecciona marcas y materiales, apoya la especificación y acompaña a arquitectos, diseñadores, tiendas de cocinas y baños, marmolistas y fabricantes de mobiliario.",
    },
    brands: {
      title: "Marcas y soluciones | IGNIVA",
      desc: "Lithotech, Foster y Mastercharge: superficies de gran formato, equipamiento de cocina y carga inalámbrica integrada.",
    },
    applications: {
      title: "Aplicaciones — Cocinas, baños, mobiliario y revestimientos | IGNIVA",
      desc: "Aplicaciones en cocinas, baños, mobiliario, revestimientos, fachadas y tecnología integrada, con las marcas presentadas por IGNIVA.",
    },
    explorer: {
      title: "Explorar soluciones | IGNIVA",
      desc: "Descubra superficies y soluciones por marca, aplicación y característica, y solicite información con el contexto ya definido.",
    },
    professionals: {
      title: "Profesionales — Arquitectos, diseñadores, cocinas y baños | IGNIVA",
      desc: "Información, documentación oficial y apoyo a la especificación para arquitectos, diseñadores, tiendas de cocinas y baños, marmolistas y fabricantes de mobiliario.",
    },
    contacts: {
      title: "Contacto | IGNIVA",
      desc: "Cuéntenos su proyecto: información de producto, muestras, documentación o presupuesto.",
    },
    quote: {
      title: "Solicitud de presupuesto | IGNIVA",
      desc: "Solicite un presupuesto: marca, aplicación y detalles del proyecto. Los importes dependen de la validación de medidas, materiales y detalles técnicos.",
    },
    privacy: {
      title: "Política de privacidad | IGNIVA",
      desc: "Cómo trata IGNIVA los datos personales recogidos a través de este sitio web.",
    },
    legal: { title: "Información legal | IGNIVA", desc: "Identificación de IGNIVA Design & Surface Solutions, Unipessoal Lda." },
  },
  nav: {
    home: "Inicio",
    about: "IGNIVA",
    brands: "Marcas",
    applications: "Aplicaciones",
    explorer: "Explorar soluciones",
    professionals: "Profesionales",
    contacts: "Contacto",
    quote: "Pedir presupuesto",
    menu_open: "Abrir menú",
    menu_close: "Cerrar menú",
  },
  common: {
    all: "Todas",
    all_m: "Todos",
    explore: "Explorar",
    request_info: "Solicitar información",
    request_quote: "Pedir presupuesto",
    next: "Siguiente",
    back: "Volver",
    submit: "Enviar solicitud",
    sending: "Enviando…",
    close: "Cerrar",
    official_site: "Sitio web oficial de la marca",
    catalogue: "Catálogos y documentación",
    catalogue_note: "Los catálogos, fichas técnicas y muestras dependen de cada marca. Hable con IGNIVA para saber qué hay disponible.",
    applications: "Aplicaciones",
    brand: "Marca",
    aesthetic: "Característica",
    step: "Paso",
    of: "de",
    origin: "Origen",
    scopes: "Aplicaciones",
    back_brands: "Volver a las marcas",
    gallery: "Aplicaciones e inspiración",
    categories: "Productos y soluciones",
    video: "Vídeo oficial",
    video_hint: "Reproducir el vídeo oficial de la marca (YouTube)",
    video_note: "Al reproducirlo, el vídeo se carga desde YouTube, que puede guardar cookies en su navegador.",
    docs: "Documentación oficial",
    image_note: "Fotografías oficiales de la marca, usadas como aplicación o inspiración. No corresponden a proyectos realizados por IGNIVA.",
    pending_image: "Imagen oficial próximamente",
    brands_label: "Marcas",
    exclusive_pt: "Distribución exclusiva en Portugal por IGNIVA",
    know_brand: "Conocer {name}",
  },
  home: {
    tag: "Arquitectura · Interiores · Superficies",
    h1a: "Superficies y soluciones",
    h1b: "para proyectos con identidad.",
    intro: "IGNIVA selecciona y representa marcas internacionales de materiales, superficies y tecnología para arquitectura e interiores.",
    cta1: "Conocer las marcas",
    cta2: "Cuéntenos su proyecto",
    slides: [
      { a: "Cocinas", b: "Lithotech — composición de cocina" },
      { a: "Encimeras", b: "Lithotech — detalle de encimera" },
      { a: "Superficies", b: "Lithotech — acabado de superficie" },
    ],
    trust: [
      "Selección rigurosa de marcas y materiales",
      "Apoyo técnico y a la especificación",
      "Vínculo entre fabricantes y profesionales",
    ],
    scroll: "Deslice para descubrir",
    manifesto_tag: "Qué hacemos",
    manifesto_title: "Entre quien fabrica y quien proyecta.",
    manifesto_text: [
      "IGNIVA acerca marcas internacionales a los profesionales de la arquitectura y el interiorismo.",
      "Seleccionamos materiales y soluciones por su calidad, diseño y rendimiento técnico, apoyando a arquitectos, diseñadores, tiendas de cocinas, fabricantes y transformadores en su integración en cada proyecto.",
      "Nuestra actividad combina conocimiento de los materiales, apoyo a la especificación y seguimiento comercial.",
    ],
    manifesto_cta: "Conocer IGNIVA",
    roles: [
      {
        t: "Selección",
        d: "Seleccionamos marcas y materiales por su calidad estética, su rendimiento técnico y sus posibilidades de aplicación.",
      },
      {
        t: "Apoyo a la especificación",
        d: "Apoyamos a los profesionales en la elección de materiales y soluciones, facilitando información técnica y la documentación oficial de los fabricantes.",
      },
      {
        t: "Seguimiento comercial",
        d: "Conectamos a fabricantes y profesionales, haciendo el seguimiento de las solicitudes de información, la especificación y el desarrollo de oportunidades.",
      },
    ],
    sectors_tag: "Para quién",
    sectors: ["Arquitectura", "Diseño de interiores", "Cocinas y baños", "Marmolistas", "Mobiliario", "Promotores"],
    brands_tag: "Marcas",
    brands_title: "Marcas y soluciones",
    brands_sub: "Marcas internacionales con propuestas distintas para arquitectura, interiorismo y mobiliario. Materiales, equipamiento y tecnología seleccionados por sus características y posibilidades de aplicación.",
    apps_tag: "Aplicaciones",
    apps_title: "Dónde se aplica cada solución.",
    apps_cta: "Ver todas las aplicaciones",
    explorer_tag: "Descubrimiento",
    explorer_title: "Explorar soluciones",
    explorer_text: "Descubra materiales y soluciones por marca, aplicación y características, y encuentre la información más relevante para su proyecto.",
    explorer_cta: "Abrir el explorador",
    cta_title: "Cuéntenos su proyecto.",
    cta_text: [
      "¿Busca información sobre materiales, equipamiento o soluciones para un proyecto?",
      "Contáctenos para solicitar documentación técnica, muestras o un presupuesto.",
    ],
    intro2: "Apoyamos a arquitectos, diseñadores y otros profesionales en la elección y especificación de soluciones para cocinas, baños, mobiliario y revestimientos.",
    apps_intro: "Materiales, equipamiento y tecnología para distintos espacios y necesidades de proyecto.",
  },
  about: {
    tag: "IGNIVA",
    title: "Entre quien fabrica y quien proyecta.",
    lead: "IGNIVA hace la curaduría de superficies y soluciones para arquitectura e interiores, con apoyo técnico y comercial cercano a los profesionales. Seleccionamos marcas y materiales, ayudamos a especificar y acompañamos cada solicitud de cerca.",
    experience: "La empresa se basa en la experiencia del fundador en el sector de la piedra y las superficies, con trayectoria en gestión comercial, desarrollo de mercados y acompañamiento de redes profesionales.",
    note: "IGNIVA no es fabricante ni instaladora.",
    note_text: "Las características de los productos pertenecen a cada marca y constan en su documentación oficial. A IGNIVA le corresponde la selección, el apoyo a la especificación y el seguimiento comercial.",
    pillars_tag: "Cómo trabajamos",
    pillars_title: "Tres formas de apoyar su proyecto.",
    pillars: [
      {
        n: "01",
        t: "Selección",
        d: "Elegimos marcas y materiales por su calidad estética y técnica y por cómo se integran en los proyectos.",
      },
      {
        n: "02",
        t: "Apoyo a la especificación",
        d: "Ayudamos a entender el material, sus aplicaciones y la documentación oficial de cada marca, para que la elección sea informada.",
      },
      {
        n: "03",
        t: "Seguimiento comercial",
        d: "Conectamos las marcas con los profesionales, con un contacto cercano desde la primera solicitud de información.",
      },
    ],
    rel_tag: "Para quién",
    rel_title: "A quién acompañamos.",
    rel_text: "Arquitectos y diseñadores de interiores, tiendas y estudios de cocinas y baños, marmolistas y empresas de transformación, fabricantes de mobiliario y promotores de proyectos residenciales, comerciales y de Hospitality. Hablamos el lenguaje técnico de quien especifica, con claridad para quien decide.",
    cta: "Cuéntenos su proyecto",
  },
  brands_page: {
    tag: "Marcas",
    title: "Marcas y soluciones",
    sub: "Marcas internacionales con propuestas distintas para arquitectura, interiorismo y mobiliario. Materiales, equipamiento y tecnología seleccionados por sus características y posibilidades de aplicación.",
    filter_all: "Todas",
    cta: "Ver marca",
  },
  brand: {
    lithotech: {
      tag: "Piedra sinterizada",
      origin: "Castellón, España",
      headline: "Superficies de gran formato.",
      categories: ["Encimeras de cocina", "Baños", "Mobiliario", "Revestimientos"],
      short: "Superficies de piedra sinterizada de gran formato para encimeras, revestimientos, mobiliario y otras aplicaciones arquitectónicas. Una selección de colores, texturas y acabados que combina expresión estética, rendimiento técnico y versatilidad de aplicación.",
      long: [
        "Lithotech es una marca española de piedra sinterizada, con sede y producción en Castellón. Sus colecciones incluyen Frame, Oda, Gubi y Allure, entre otras.",
        "La marca desarrolla tecnología propia, como Corelith® y 3D·Fit®, para superficies con relieve y sinterización controlada. Las colecciones Frame, Oda y Gubi recurren a 3D·Fit® para hacer coincidir el dibujo con el relieve de la superficie.",
        "IGNIVA asegura la distribución exclusiva de Lithotech en Portugal. Los formatos, espesores, acabados y características técnicas de cada colección constan en el catálogo y las fichas técnicas oficiales.",
      ],
      ambitos: ["Encimeras de cocina", "Baños", "Mobiliario", "Revestimientos"],
      desc: [
        "Superficies de piedra sinterizada de gran formato para encimeras, revestimientos, mobiliario y otras aplicaciones arquitectónicas.",
        "Una selección de colores, texturas y acabados que combina expresión estética, rendimiento técnico y versatilidad de aplicación.",
      ],
    },
    foster: {
      tag: "Equipamiento para cocina",
      origin: "Brescello, Italia",
      headline: "Fregaderos y grifos para la cocina.",
      categories: ["Fregaderos", "Grifos"],
      short: "Equipamiento de cocina en acero inoxidable, desarrollado con especial atención al diseño, la funcionalidad y la integración en los espacios. Fregaderos, grifos, placas y otras soluciones que combinan tecnología y diseño italiano.",
      long: [
        "Foster es una empresa italiana fundada en 1973, con sede en Brescello y cuatro plantas de producción. Trabaja el acero inoxidable (AISI 304 y AISI 316) en fregaderos, grifos y otro equipamiento de cocina.",
        "Entre los acabados de la marca figuran el acero satinado y los colores PVD, como Gun Metal, Gold y Copper. Para información sobre gamas y acabados, hable con IGNIVA o consulte el sitio web oficial de la marca.",
      ],
      ambitos: ["Cocinas"],
      desc: [
        "Equipamiento de cocina en acero inoxidable, desarrollado con especial atención al diseño, la funcionalidad y la integración en los espacios.",
        "Fregaderos, grifos, placas y otras soluciones que combinan tecnología y diseño italiano.",
      ],
    },
    mastercharge: {
      tag: "Carga inalámbrica integrada",
      origin: "Reino Unido",
      headline: "El teléfono se carga al apoyarlo sobre la encimera.",
      categories: ["Carga bajo encimeras", "Carga en mobiliario y mesas"],
      short: "Tecnología de carga inalámbrica integrada bajo superficies compatibles, que permite cargar dispositivos sin cargadores ni cables visibles sobre la encimera. Una solución discreta para cocinas, mesas y mobiliario que aporta funcionalidad sin comprometer el diseño.",
      long: [
        "Mastercharge desarrolla cargadores inalámbricos (Qi) para instalar bajo encimeras, mesas y mobiliario, sin elementos a la vista. Basta apoyar el teléfono sobre la superficie para empezar a cargar.",
        "La carga atraviesa materiales como madera, piedra y vidrio, pero no funciona a través de metal. La distancia máxima, la potencia y la compatibilidad dependen del modelo y del material: consulte el manual oficial y hable con IGNIVA antes de especificar.",
      ],
      ambitos: ["Encimeras de cocina", "Mobiliario y mesas"],
      desc: [
        "Tecnología de carga inalámbrica integrada bajo superficies compatibles, que permite cargar dispositivos sin cargadores ni cables visibles sobre la encimera.",
        "Una solución discreta para cocinas, mesas y mobiliario que aporta funcionalidad sin comprometer el diseño.",
      ],
    },
  },
  apps_page: {
    tag: "Aplicaciones",
    title: "Dónde se aplica cada solución.",
    sub: "Elija una aplicación para ver las marcas y soluciones correspondientes. Las imágenes son fotografías oficiales de las marcas, usadas como aplicación o inspiración.",
    brands_for: "Marcas para esta aplicación",
  },
  app_items: {
    cozinhas: "Cocinas",
    banhos: "Baños",
    mobiliario: "Mobiliario",
    revestimentos: "Revestimientos",
    fachadas: "Fachadas",
    integrada: "Tecnología integrada",
  },
  app_cats: {
    cozinhas: "Cocinas",
    banhos: "Baños",
    mobiliario: "Mobiliario",
    revestimentos: "Revestimientos",
    fachadas: "Fachadas",
    integrada: "Tecnología integrada",
  },
  categories: { superficies: "Superficies", equipamento: "Equipamiento de cocina", tecnologia: "Tecnología integrada" },
  explorer: {
    tag: "Descubrimiento",
    title: "Explorar soluciones",
    sub: "Filtre por marca, categoría, aplicación y característica.",
    filter_brand: "Marca",
    filter_app: "Aplicación",
    filter_aes: "Característica",
    filter_cat: "Categoría",
    empty: "Ninguna solución coincide con los filtros seleccionados.",
    detail_cta: "Solicitar información",
    detail_brand: "Marca",
  },
  explorer_items: {
    "lithotech-superficies": {
      name: "Superficies Lithotech",
      desc: "Superficies de gran formato para encimeras de cocina, baños y mobiliario, según la documentación técnica de cada producto.",
    },
    "lithotech-revestimentos": {
      name: "Revestimientos de gran formato",
      desc: "Gran formato para revestimientos interiores, según el producto y la documentación oficial de la marca.",
    },
    "foster-lava-loucas": { name: "Fregaderos Foster", desc: "Fregaderos de acero inoxidable para la cocina." },
    "foster-torneiras": { name: "Grifos Foster", desc: "Grifos para la cocina, con distintos acabados." },
    "mastercharge-carregamento": {
      name: "Carga inalámbrica integrada",
      desc: "Carga inalámbrica integrada en encimeras, mesas y mobiliario. La compatibilidad depende de la documentación técnica de la marca.",
    },
  },
  aesthetics: { pedra: "Piedra", aco: "Acero inoxidable", integrado: "Integrado", grande_formato: "Gran formato" },
  quote: {
    tag: "Presupuesto",
    title: "Solicitud de presupuesto",
    sub: "Cuatro pasos sencillos. Los importes dependen de la validación de medidas, materiales y detalles técnicos, por lo que respondemos tras analizar su solicitud.",
    steps: ["Marca", "Aplicación", "Proyecto", "Contacto"],
    s1_title: "¿Qué marca le interesa?",
    s2_title: "¿Qué aplicación?",
    s3_title: "Sobre el proyecto",
    tipo: "Tipo de proyecto",
    quantidade: "Cantidad estimada (m², unidades…)",
    localizacao: "Ubicación del proyecto",
    tipos: { residencial: "Residencial", hospitality: "Hospitality", comercial: "Comercial", retalho: "Retail", outro: "Otro" },
    files_hint: "¿Tiene planos o archivos técnicos? Tras enviar la solicitud, envíelos a",
    s4_title: "Sus datos de contacto",
    review: "Resumen de la solicitud",
    new: "Nueva solicitud",
  },
  pros: {
    tag: "Profesionales",
    title: "Soluciones para quien proyecta y transforma.",
    sub: [
      "Trabajamos con arquitectos, diseñadores, tiendas y estudios de cocinas y baños, marmolistas, fabricantes de mobiliario y promotores.",
      "Ponemos a su disposición información sobre materiales, documentación técnica y apoyo comercial para facilitar la elección e integración de las soluciones en cada proyecto.",
    ],
    benefits_tag: "Cómo ayudamos",
    benefits_title: "Trabajar con IGNIVA",
    benefits: [
      "Selección de marcas y materiales con criterio",
      "Documentación oficial de las marcas para apoyar la especificación",
      "Muestras, siempre que la marca las ponga a disposición",
      "Un interlocutor para solicitudes de información y presupuesto",
    ],
    res_tag: "Recursos",
    res_title: "Documentación por marca",
    res_note: "Los catálogos, fichas técnicas y muestras dependen de cada marca. Puede consultar la documentación oficial pública o pedirnos información.",
    res_site: "Sitio oficial",
    res_docs: "Catálogos y documentación",
    form_tag: "Contacto profesional",
    form_title: "Preséntese a IGNIVA",
    tipo: "Perfil profesional",
    tipos: {
      arquiteto: "Arquitecto/a",
      designer: "Diseñador de interiores",
      estudio_cozinhas: "Tienda o estudio de cocinas y baños",
      marmorista: "Marmolista",
      fabricante: "Fabricante de mobiliario",
      promotor: "Promotor",
      outro: "Otro",
    },
    areas: [
      {
        t: "Información técnica",
        d: "Acceso a la documentación oficial de los fabricantes, características de los materiales y recomendaciones de aplicación.",
      },
      {
        t: "Muestras y materiales",
        d: "Apoyo en la identificación de referencias y en la solicitud de muestras para evaluación y especificación.",
      },
      {
        t: "Seguimiento comercial",
        d: "Coordinación con fabricantes y socios para responder a solicitudes de información y desarrollar oportunidades de proyecto.",
      },
    ],
  },
  contact: {
    tag: "Contacto",
    title: "Cuéntenos su proyecto.",
    sub: "Información de producto, muestras, documentación o presupuesto: díganos qué busca y le responderemos por email.",
    assunto: "Tipo de solicitud",
    assuntos: { info: "Información", amostras: "Muestras", orcamento: "Presupuesto", outro: "Otro" },
    email_label: "Email",
    phone_label: "Teléfono",
    form_title: "Envíe su mensaje",
  },
  form: {
    nome: "Nombre",
    empresa: "Empresa",
    email: "Email",
    telefone: "Teléfono (opcional)",
    atividade: "Actividad profesional",
    mensagem: "Mensaje",
    atividades: [
      "Arquitectura",
      "Diseño de interiores",
      "Tienda o estudio de cocinas y baños",
      "Marmolista o transformación",
      "Fabricante de mobiliario",
      "Promotor o proyectos comerciales",
      "Cliente particular",
      "Otra",
    ],
    gdpr: "Autorizo el tratamiento de mis datos para responder a esta solicitud, conforme a la",
    gdpr_link: "Política de privacidad",
    send: "Enviar mensaje",
    required: "Campo obligatorio",
    success_title: "Gracias por su contacto.",
    success_text: "Hemos recibido su solicitud y nos pondremos en contacto con usted lo antes posible.",
    error: "No se ha podido enviar su solicitud. Por favor, inténtelo de nuevo o contáctenos a través de {email}.",
    another: "Enviar otra solicitud",
  },
  privacy: {
    tag: "Privacidad",
    title: "Política de privacidad",
    updated: "El texto legal está disponible en portugués y está sujeto a validación final por IGNIVA antes de su publicación.",
  },
  footer: {
    tagline: "Selección y representación de marcas internacionales de materiales, superficies y tecnología para arquitectura e interiores.",
    nav: "Navegación",
    brands: "Marcas",
    contact: "Contacto",
    rights: "Todos los derechos reservados.",
    privacy: "Política de privacidad",
    legal_info: "Información legal",
  },
  legal: {
    tag: "Información legal",
    title: "Identificación del prestador",
    intro: "Información facilitada conforme al artículo 10 del Decreto-Ley portugués n.º 7/2004 (servicios de la sociedad de la información).",
    name: "Denominación social",
    nif: "NIF / NIPC",
    seat: "Domicilio social",
    email: "Correo electrónico",
  },
};
